<template>
  <div style="min-height: 100vh">
    <navbar />
    <b-container>
      <b-tabs content-class="mt-3">
        <b-tab title="เอกสารโครงการ" active>
          <document_first
            :data="data"
            :dataCateName="dataCateName"
            :firstTotal="firstTotal"
            :selectedGroup="selectedGroup"
          />
        </b-tab>
        <b-tab title="หนังสือ/บทความ/เอกสารเผยแพร่">
          <document_second
            :document="document"
            :lastPage="lastPage"
            :secondTotal="secondTotal"
            @page="pageTwo"
          />
        </b-tab>
      </b-tabs>
    </b-container>

    <!--    <document_first-->
    <!--      :data="data"-->
    <!--      :dataCateName="dataCateName"-->
    <!--      :firstTotal="firstTotal"-->
    <!--    />-->
    <!--    <document_second-->
    <!--      class="mt-5"-->
    <!--      :document="document"-->
    <!--      :lastPage="lastPage"-->
    <!--      :secondTotal="secondTotal"-->
    <!--      @page="pageTwo"-->
    <!--    />-->
  </div>
</template>

<script>
import Document_first from "@/components/document_first";
import Document_second from "@/components/document_second";
import Navbar from "@/components/navbar";
export default {
  name: "DocumentMain",
  components: { Navbar, Document_second, Document_first },
  data() {
    return {
      data: [],
      dataCateName: [],
      document: [],
      lastPage: null,
      firstTotal: null,
      secondTotal: null,
      selectedGroup: null,
    };
  },
  created() {
    let data = {
      page: 1,
    };
    this.$store.dispatch("dashboardModule/documentMain", data).then((res) => {
      this.data = res.cate_one;
      this.firstTotal = this.data[Object.keys(this.data)[0]].length;
      this.dataCateName = res.cate_one_name;
      this.document = res.cate_two;
      this.lastPage = res.cate_two.last_page;
      this.secondTotal = res.cate_two.total;
      this.dataCateName.forEach((x, i) => {
        if (i == 0) this.selectedGroup = x.id;
      });
    });
  },
  methods: {
    pageTwo(filter) {
      let data = {
        year: filter.year,
        month: filter.month,
        category: filter.category,
        page: filter.page,
      };
      this.$store.dispatch("dashboardModule/documentMain", data).then((res) => {
        // this.data = res.cate_one;
        // this.dataCateName = res.cate_one_name;
        this.document = res.cate_two;
        // this.firstTotal = this.data[Object.keys(this.data)[0]].length;
        this.lastPage = res.cate_two.last_page;
        this.secondTotal = res.cate_two.total;
      });
    },
  },
};
</script>

<style scoped></style>
